module.exports = __webpack_public_path__ + "media/images/landing/partner_logos/kraft-d9c22fd898f98b6b56b9be870e4e2bd9.png";